import script from "./RoleSectionSubContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSectionSubContent.vue?vue&type=script&setup=true&lang=ts"

import "./RoleSectionSubContent.vue?vue&type=style&index=0&id=3b0d7fe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0d7fe8"]])

export default __exports__